// Shared rotating index using a single interval
// This prevents memory spikes by using ONE interval for all subscribers
// instead of each component creating its own interval.

type RotationListener = (index: number) => void

export class SharedRotatingIndex {
    private index = 0
    private listeners = new Set<RotationListener>()
    private intervalId: ReturnType<typeof setInterval> | null = null
    private readonly intervalMs: number

    constructor(intervalMs: number) {
        this.intervalMs = intervalMs
    }

    subscribe(listener: RotationListener): () => void {
        this.listeners.add(listener)

        // Start interval if this is the first subscriber
        if (this.listeners.size === 1 && !this.intervalId) {
            this.intervalId = setInterval(() => {
                this.index += 1
                this.listeners.forEach(l => l(this.index))
            }, this.intervalMs)
        }

        // Return unsubscribe function
        return () => {
            this.listeners.delete(listener)

            // Stop interval if no more subscribers
            if (this.listeners.size === 0 && this.intervalId) {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        }
    }

    getCurrentIndex(): number {
        return this.index
    }
}
